export default __webpack_public_path__ + "static/media/physiological.6a24170e.jpg";